import React from 'react';
import useNotDownloadedAssets from './hooks/useNotDownloadedAssets';
import NotDownloadedAssets from './NotDownloadedAssets';

const Container: React.FC = () => {
  const data = useNotDownloadedAssets();

  if (!data) return null;

  return (
    <NotDownloadedAssets
      assetIds={data.assetIds}
      isQuotaExceeded={data.isQuotaExceeded}
    />
  );
};

export default Container;
